var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { PhoenixLoader } from './phoenix-loader';
/**
 * PhoenixLoader for processing and loading an LHCb event.
 */
var LHCbLoader = /** @class */ (function (_super) {
    __extends(LHCbLoader, _super);
    /**
     * Constructor for the LHCb loader.
     */
    function LHCbLoader() {
        var _this = _super.call(this) || this;
        _this.data = {};
        return _this;
    }
    /**
     * Set the event data for the loader.
     * @param data Event data as JSON.
     */
    LHCbLoader.prototype.process = function (data) {
        console.log('Processing event data');
        this.data = data;
    };
    /**
     * Process and get the event data.
     * @returns The processed event data.
     */
    LHCbLoader.prototype.getEventData = function () {
        var eventData = {
            eventNumber: this.data.eventNumber,
            runNumber: this.data.runNumber,
            Hits: {},
            Tracks: {}
        };
        var part_list = [];
        var pdata_list = this.data.PARTICLES;
        if (pdata_list) {
            for (var j = 0; j < pdata_list.length; j++) {
                var pdata = pdata_list[j];
                var mom = Math.pow(pdata.px, 2) + Math.pow(pdata.py, 2) + Math.pow(pdata.pz, 2);
                var part = {
                    particle_id: pdata.name,
                    pos: pdata.track,
                    mom: mom
                };
                part_list.push(part);
            }
        }
        eventData.Tracks = { Particles: part_list };
        return eventData;
    };
    /**
     * Get LHCb specific metadata associated to the event (experiment info, time, run, event...).
     * @returns Metadata of the event.
     */
    LHCbLoader.prototype.getEventMetadata = function () {
        var metadata = _super.prototype.getEventMetadata.call(this);
        if (this.data['time']) {
            metadata.push({
                label: 'Data recorded',
                value: this.data['time']
            });
        }
        return metadata;
    };
    return LHCbLoader;
}(PhoenixLoader));
export { LHCbLoader };
//# sourceMappingURL=lhcb-loader.js.map